<template>
  <base-row :class="$style.row">
    <div :class="contentStyles">
      <slot
        name="default"
        :title-class="$style.primaryTitle"
        :title="title"
      >
        <span
          :class="$style.primaryTitle"
          data-qa="primary-title"
        >{{ title }}</span>
      </slot>
      <button
        v-if="shouldShowCloseButton"
        type="button"
        data-qa="close"
        :class="$style.closeButton"
        @click="handleClose"
      >
        <ui-icon name="close-28" />
      </button>
    </div>
  </base-row>
</template>

<script setup lang="ts">
import { inject, computed, useCssModule } from 'vue';
import { UiIcon } from '@huntflow/ui';
import { removeLayerSymbol } from '@/shared/legacy/ui/base-layer/constants';
import BaseRow from './row.vue';

defineOptions({
  name: 'LayoutHeader'
});

const { title = '', allowClose = 'layer', borderAfter = true } = defineProps<{
  title?: string;
  allowClose?: false | 'layer' | 'event-only';
  borderAfter?: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();

const removeLayer: any = inject(removeLayerSymbol);

const shouldShowCloseButton = computed(() => allowClose === 'event-only' || (allowClose === 'layer' && removeLayer));

const handleClose = () => {
  emit('close');
  if (allowClose !== 'event-only' && removeLayer) {
    removeLayer();
  }
};

const styles = useCssModule();

const contentStyles = computed(() => ({
  [styles.content]: true,
  [styles.borderAfter]: borderAfter
}));
</script>

<style module>
.content {
  padding: 20px 24px 20px 24px !important;
  color: #050505;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: space-between;
}

.borderAfter {
  border-bottom: 1px solid var(--border-neutral-S, rgba(0, 0, 0, 0.08));
}

.primaryTitle {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-size: var(--hf-font-size-text-h3);
  line-height: var(--hf-font-line-height-text-h3);
  font-weight: var(--hf-font-weight-text-h3-medium);
}

.closeButton {
  @mixin reset-button-styles;
  flex: 0 0 auto;
  cursor: pointer;
  color: #a5a5a5;
  border-radius: 8px;
  &:hover,
  &:focus {
    background-color: $black-7;
  }
  &:active {
    background-color: #ebebeb;
  }
}

.row {
  background-color: $white;
  border-radius: var(--Radius-x4, 16px) var(--Radius-x4, 16px) 0 0;
}
</style>

<i18n lang="json">{}</i18n>
